module.exports = __webpack_public_path__ + "img/cbdwkh.7139047f.png";